var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgChefSvgrepoCom(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 56 56",
    style: {
      enableBackground: "new 0 0 56 56"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EDEDED"
    },
    d: "M44.639,6.147c-2.08-0.269-4.06-0.012-5.87,0.612C36.432,3.309,32.481,1.041,28,1.041 s-8.432,2.268-10.77,5.718c-1.81-0.623-3.79-0.881-5.87-0.612C4.995,6.971,0.055,12.509,0,18.927 c-0.052,6.143,4.157,11.313,9.85,12.729c1.911,0.476,3.313,2.104,3.5,4.064l1.317,13.832c0.188,1.977,3.835,3.487,3.835,3.487 c6.073,2.558,12.921,2.558,18.994,0c0,0,3.647-1.51,3.835-3.487l1.317-13.832c0.187-1.96,1.589-3.589,3.5-4.064 c5.693-1.417,9.902-6.586,9.85-12.729C55.945,12.509,51.005,6.971,44.639,6.147z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E6E6E6"
    },
    d: "M28,50.041c-4.876,0-9.494-1.301-13.63-3.617l0.298,3.129c0.188,1.977,3.835,3.487,3.835,3.487 c6.073,2.558,12.921,2.558,18.994,0c0,0,3.647-1.51,3.835-3.487l0.298-3.129C37.494,48.74,32.876,50.041,28,50.041z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M18.999,44.041c-0.497,0-0.928-0.37-0.991-0.876l-1-8c-0.068-0.548,0.32-1.048,0.868-1.116 c0.542-0.063,1.047,0.32,1.116,0.868l1,8c0.068,0.548-0.32,1.048-0.868,1.116C19.082,44.038,19.04,44.041,18.999,44.041z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M25,46.041c-0.552,0-1-0.447-1-1v-8c0-0.553,0.448-1,1-1s1,0.447,1,1v8 C26,45.594,25.552,46.041,25,46.041z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M37.001,44.041c-0.042,0-0.083-0.003-0.125-0.008c-0.548-0.068-0.937-0.568-0.868-1.116l1-8 c0.068-0.548,0.573-0.931,1.116-0.868c0.548,0.068,0.937,0.568,0.868,1.116l-1,8C37.929,43.671,37.498,44.041,37.001,44.041z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M31,46.041c-0.552,0-1-0.447-1-1v-8c0-0.553,0.448-1,1-1s1,0.447,1,1v8 C32,45.594,31.552,46.041,31,46.041z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D2D5D7"
    },
    d: "M32.999,8.041c-0.198,0-0.397-0.059-0.572-0.181c-4.594-3.208-8.775-0.06-8.816-0.027 c-0.437,0.335-1.065,0.256-1.403-0.181c-0.337-0.438-0.257-1.065,0.18-1.403c1.845-1.422,6.555-3.262,11.184-0.027 c0.453,0.315,0.563,0.939,0.247,1.392C33.625,7.891,33.315,8.041,32.999,8.041z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E6E6E6"
    },
    d: "M43.042,6.085c-1.502,0-2.938,0.269-4.279,0.739C36.436,3.361,32.485,1.082,28,1.082 c-4.474,0-8.419,2.268-10.747,5.716c-1.322-0.455-2.735-0.714-4.211-0.714c-7.157,0-12.958,5.802-12.958,12.958 s5.802,12.958,12.958,12.958c1.452,0,2.843-0.25,4.147-0.69c1.868,1.045,4.019,1.646,6.311,1.646c2.13,0,4.134-0.523,5.906-1.434 c2.031,1.321,4.449,2.096,7.052,2.096c2.284,0,4.427-0.596,6.291-1.633c0.098,0.002,0.194,0.015,0.293,0.015 C50.198,32.001,56,26.2,56,19.043S50.198,6.085,43.042,6.085z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M6.001,18.041c-0.071,0-0.143-0.008-0.215-0.023c-0.539-0.118-0.881-0.651-0.762-1.19 c0.015-0.068,1.584-6.787,9.822-6.787c0.055,0,0.11,0,0.166,0.001c0.552,0.006,0.995,0.459,0.989,1.011 c-0.006,0.549-0.453,0.989-1,0.989c-0.054-0.007-0.102-0.001-0.151-0.001c-6.652,0-7.86,5.162-7.872,5.215 C6.875,17.722,6.46,18.041,6.001,18.041z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", null)), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", null)));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChefSvgrepoCom);
export default __webpack_public_path__ + "static/media/chef-svgrepo-com.2f8756ef4ed96b378d43a46d08bff060.svg";
export { ForwardRef as ReactComponent };